import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spinner } from 'react-bootstrap';

/**
 * Modal que muestra un indicador de carga mientras se descarga la nota de venta
 */
const ModalDescargaNotaVenta = ({ show }) => {
    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body className="text-center py-4">
                <Spinner animation="border" variant="primary" className="mb-3" />
                <h5 className="mb-2">Descargando Nota de Venta</h5>
                <p className="text-muted mb-0">
                    Por favor espere mientras se descarga el archivo...
                </p>
            </Modal.Body>
        </Modal>
    );
};

ModalDescargaNotaVenta.propTypes = {
    show: PropTypes.bool.isRequired
};

export default ModalDescargaNotaVenta;
